import { render, staticRenderFns } from "./SelectStockBatch.vue?vue&type=template&id=20c23925&scoped=true&"
import script from "./SelectStockBatch.vue?vue&type=script&lang=ts&"
export * from "./SelectStockBatch.vue?vue&type=script&lang=ts&"
import style0 from "./SelectStockBatch.vue?vue&type=style&index=0&id=20c23925&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c23925",
  null
  
)

export default component.exports